export const summaryRows: string[] = [
  'Volume 1 — Fondamenti delle Energie Rinnovabili: Energia, Conversione e Sistemi',
  'Volume 2 — Energia Solare: Fotovoltaico e Solare Termico',
  "Volume 3 — Energia Eolica: dal Vento all'Elettricità",
  'Volume 4 — Acqua, Terra e Biomassa',
  'Volume 5 — Accumulo, Smart Grid e Rinnovabili nel Mondo Reale',
  'Volume 6 — Insegnare le Energie Rinnovabili',
  'Bonus 1 — 30 Schede di Attività in Classe sulle Energie Rinnovabili',
  'Bonus 2 — Banca di Quiz e Verifiche Rapide con Soluzioni',
  'Bonus 3 — 10 Esperimenti di Laboratorio Low-Cost sulle Energie Rinnovabili',
  'Bonus 4 — Glossario Illustrato delle Energie Rinnovabili: 150 Concetti Spiegati per la Classe',
  'Bonus 5 — Progetti Interdisciplinari ed Educazione Civica sulla Sostenibilità Energetica',
  'Garanzia di soddisfazione di 7 giorni',
  'Accesso immediato',
];
